import React, { createContext, useContext, useEffect, useState } from 'react';
import { io } from 'socket.io-client';
import { useAuthentication } from './authentication';

const SocketContext = createContext(null);

export function useSocket() {
  return useContext(SocketContext);
};

export default function SocketProvider({ children }) {
  const { account, logout } = useAuthentication();
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    const newSocket = io(process.env.REACT_APP_TERMINAL, {
      transports: ['websocket'],
      auth: { token: account.token }
    });

    newSocket.on('connect_error', (err) => {
      logout();
    });
    setSocket(newSocket);

    return () => {
      newSocket.disconnect();
    };
  }, []);

  return (
    <SocketContext.Provider value={socket}>
      {children}
    </SocketContext.Provider>
  );
};
